import styled from "styled-components";

export const PointsSection = styled.div`
    display: grid;
    justify-items: center;
    grid-gap: 8px;
    color: white;
`;

export const SectionTitle = styled.div`
    font-weight: 100;
    font-size: 24px;
    letter-spacing: 6px;
`;

export const PointsAmount = styled.div`
    font-size: 90px;
`;